import { useTranslation } from "react-i18next";
import { useApi } from "../hooks/useApi";
import { ApiError, api } from "../lib/api";

export function AdminAudit(): JSX.Element {
  const { t } = useTranslation();
  const events = useApi(() => api.admin.audit(200), []);

  if (events.status === "loading") {
    return <p className="launchpad__hint">{t("admin.loading")}</p>;
  }
  if (events.status === "error") {
    const msg = events.error instanceof ApiError ? events.error.message : events.error.message;
    return <p className="launchpad__hint launchpad__hint--error">{msg}</p>;
  }

  return (
    <section className="admin">
      <h2>{t("admin.auditTitle")}</h2>
      <table className="admin__table">
        <thead>
          <tr>
            <th>{t("admin.audit.created")}</th>
            <th>{t("admin.audit.actor")}</th>
            <th>{t("admin.audit.action")}</th>
            <th>{t("admin.audit.entity")}</th>
          </tr>
        </thead>
        <tbody>
          {events.data.events.map((e) => (
            <tr key={e.id}>
              <td>
                <code>{new Date(e.created_at).toLocaleString()}</code>
              </td>
              <td>
                {e.actor_display ? (
                  <span title={e.actor_id}>{e.actor_display}</span>
                ) : (
                  <code title={t("admin.audit.actorUnresolved")}>{e.actor_id}</code>
                )}
              </td>
              <td>{e.action}</td>
              <td>
                <code>
                  {e.entity_type} / {e.entity_id}
                </code>
              </td>
            </tr>
          ))}
          {events.data.events.length === 0 ? (
            <tr>
              <td colSpan={4} className="admin__empty">
                {t("admin.audit.empty")}
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </section>
  );
}
